/** @file The name of an entity by kind and id (the id itself when the entity no longer exists). */
import { ENTITY_KINDS } from '@pose2d/format/doc/entityKinds';
import type { Doc, EntityKind, Id } from '@pose2d/format/types';

/** `doc[table][id].name`, else `id`. */
export function entityName(doc: Doc, kind: EntityKind, id: Id): string {
  const table = doc[ENTITY_KINDS[kind]] as Readonly<Record<string, { name: string } | undefined>>;
  return table[id]?.name ?? id;
}
